import { SetStateAction, useEffect, useState } from 'react';
import CustomSelect from '../../../../../components/common/SelectField';
import { Grid, MenuItem, Tooltip } from '@mui/material';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { TableInput } from '../../../../../components/common';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import moment from 'moment';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';
import { TimePicker } from '@mui/x-date-pickers';
import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../../components/common/button/CustomIconButton';
import formatDate from '../../../../../components/common/formatDate';
import { convToTime } from '../../../../../utils/helpers';
import CustomMobileTimePickerMui from '../../../../../components/common/CustomMobileTimePickerMui';
import Operator from '../../../components/Operator';
import OperationSelect from '../OperationSelect';
import convToTime24 from '../../../../../utils/helpers/convToTime';
import ModalCustom from '../../../../../components/common/Modal';
import OperatorFor4mLogs from './OperatorFor4mLogs';
import OperatorSelect from './OperatorSelect';
import axios from 'axios';
interface IProps {
  moduleData: any;
  isView: boolean;
  handleSumbit: any;
  processData: any;
  autoCompleteMachineValue: any;
  handelDeleteRows: any;
  isOpenPopup: any;
  setIsOpenPopup: any;
  setPartIdx: any;
  setIsOpenPopupRejections: any;
  setRejectionsIndx: any;
  setReasonType: any;
}
const IsComplete = (process: any) => {
  let totalRejectionQty = process?.reasons_for_rej?.reduce(
    (sum: number, item: any) => sum + +item.rej_qty,
    0,
  );
  totalRejectionQty += process?.reasons_for_less_prod?.reduce(
    (sum: number, item: any) => sum + +item.rej_qty,
    0,
  );
  const ngQty = process.prod_qty - process.accepted_qty;
  if (ngQty - totalRejectionQty === 0) return true;
  return false;
};

const TBody = ({
  moduleData,
  isView,
  handleSumbit,
  processData,
  autoCompleteMachineValue,
  handelDeleteRows,
  isOpenPopup,
  setIsOpenPopup,
  setPartIdx,
  setIsOpenPopupRejections,
  setRejectionsIndx,
  setReasonType,
}: IProps) => {
  const [render, setRender] = useState(false);
  const [isOpen4mModel, setIsOpen4mModel] = useState(false);
  const [modalIdx, setModalIdx] = useState<any>(null);
  const [machineData, setMachineData] = useState([]);
  useEffect(() => {
    axios
      .get('/api/machineRoutes/machine/ForAutocomplete')
      .then((res) => {
        setMachineData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <tbody>
        {moduleData &&
          moduleData.processes.map((process: any, index: number) => (
            <tr key={index + 'module data'}>
              <td width={'100px'} style={{ fontWeight: 'bold' }}>
                {index + 1}
              </td>

              <td style={{ minWidth: '200px' }}>
                {isView ? (
                  formatDate(process.process_date)
                ) : (
                  <DatePickerMui
                    label=""
                    value={moment(process.process_date || '')}
                    onChange={(date) => {
                      process.process_date = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '200px' }}>
                {isView ? (
                  process?.process_id?.process_name
                ) : (
                  <AutocompleteMuiCustom
                    id="process_name"
                    label=""
                    option_name="process_name"
                    arrayofObj={processData}
                    value={process?.process_name || process?.process_id || ''}
                    onChange={(e, value) => {
                      if (value !== null) {
                        process.process_id = value._id;
                        process.process_name = value;
                      }
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '200px' }}>
                <TableInput
                  isView={isView}
                  name="sub_process_name"
                  type="text"
                  value={process.sub_process_name}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '200px' }}>
                {isView ? (
                  process?.machine_id?.machine_no
                ) : (
                  <AutocompleteMuiCustom
                    id="Machine"
                    label=""
                    option_name="machine_no"
                    arrayofObj={machineData || []}
                    value={process?.machine_id || ''}
                    onChange={(e, value) => {
                      process.machine_id = value;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '150px' }}>
                {isView ? (
                  convToTime(process.time_start)
                ) : (
                  <TimePicker
                    // ampm={false}
                    value={moment(process.time_start)}
                    onChange={(date: any) => {
                      process.time_start = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '150px' }}>
                {isView ? (
                  convToTime(process.time_stop)
                ) : (
                  <TimePicker
                    // ampm={false}
                    value={moment(process.time_stop)}
                    onChange={(date: any) => {
                      process.time_stop = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '200px' }}>
                <OperatorSelect
                  processId={process?.process_id?._id || process?.process_id}
                  field="operator"
                  partId={moduleData?.part_id?._id || moduleData?.part_id}
                  process={process}
                  isView={isView}
                />
              </td>
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  isView={isView}
                  name="plan_qty"
                  type="number"
                  value={process.plan_qty}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  isView={isView}
                  name="prod_qty"
                  type="number"
                  value={process.prod_qty}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  isView={isView}
                  name="accepted_qty"
                  type="number"
                  value={process.accepted_qty}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  isView={isView}
                  name="bd_time"
                  type="text"
                  value={process.bd_time}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '150px' }}>
                {process.prod_qty - process.accepted_qty}
              </td>
              <td
                style={{
                  width: '280px',
                  minWidth: '280px',
                  textAlign: 'center',
                }}
              >
                <Grid
                  container
                  xs={12}
                  direction="row"
                  alignItems={'center'}
                  sx={
                    IsComplete(process)
                      ? { background: 'green' }
                      : { background: 'red' }
                  }
                >
                  <Grid item xs={10}>
                    <p
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Click on + icon for reason and qty
                    </p>
                  </Grid>
                  <Grid item xs={2}>
                    <AddIconButton
                      tooltipTitle="add reasons and qty"
                      onClick={() => {
                        setIsOpenPopupRejections(true);
                        setRejectionsIndx(index);
                        setReasonType('rejection');
                      }}
                    />
                  </Grid>
                </Grid>
              </td>
              <td
                style={{
                  width: '280px',
                  minWidth: '280px',
                  textAlign: 'center',
                }}
              >
                <Grid
                  container
                  xs={12}
                  direction="row"
                  alignItems={'center'}
                  sx={
                    IsComplete(process)
                      ? { background: 'green' }
                      : { background: 'red' }
                  }
                >
                  <Grid item xs={10}>
                    <p
                      style={{
                        fontSize: '1.2rem',
                        fontWeight: 'bold',
                      }}
                    >
                      Click on + icon for reason and qty
                    </p>
                  </Grid>
                  <Grid item xs={2}>
                    <AddIconButton
                      tooltipTitle="add reasons and qty"
                      onClick={() => {
                        setIsOpenPopupRejections(true);
                        setRejectionsIndx(index);
                        setReasonType('production');
                      }}
                    />
                  </Grid>
                </Grid>
              </td>
              <td style={{ minWidth: '200px' }} colSpan={isView ? 2 : 1}>
                <TableInput
                  isView={isView}
                  name="remarks"
                  type="text"
                  value={process.remarks}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              {/* {!isView && (
                <td style={{ minWidth: '100px' }}>
                  <AddIconButton
                    tooltipTitle={'Add To 4M'}
                    disabled={true}
                    onClick={() => {
                      setModalIdx(index);
                      setIsOpen4mModel(true);
                    }}
                  />
                </td>
              )} */}
              {!isView && (
                <td style={{ minWidth: '100px' }}>
                  <DeleteIconButton
                    tooltipTitle={'delete'}
                    onClick={() => handelDeleteRows(index)}
                  />
                </td>
              )}
            </tr>
          ))}
      </tbody>
      {/* <ModalCustom
        title="SUMMARY DATA"
        openModal={isOpen4mModel}
        closeModal={() => {
          setIsOpen4mModel(false);
        }}
      >
        <OperatorFor4mLogs
          onSubmit={handleSumbit}
          field="operator"
          machineId={moduleData?.processes?.[modalIdx]?.mc_no?._id}
          dataObj={{
            date: moduleData?.dailyProduction_date,
            part_id: moduleData?.processes?.[modalIdx]?.part_id,
            operation_name: moduleData?.processes?.[modalIdx]?.operation_name,
          }}
          process={moduleData?.processes?.[modalIdx]}
          {...{ isView, isOpen4mModel, setIsOpen4mModel }}
        />
      </ModalCustom> */}
    </>
  );
};

export default TBody;
